var map = {
	"./buyOneGetOneFree.json": 803,
	"./cashVoucherWithPurchase.json": 804,
	"./discountedProductWithPurchase.json": 805,
	"./freeGift.json": 806,
	"./giftWithPurchase.json": 807,
	"./priceDiscount.json": 808,
	"./priceReduction.json": 809,
	"./prizeDrawWithPurchase.json": 810,
	"./productIntroduction.json": 811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 802;